import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";
import { mapSellingAdditionalServiceToServer } from "./mappers/mapSellingAdditionalServiceToServer";

export const updateSellingAdditionalService = async (sessionKey, service) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/update/service`,
            method: "PUT",
            data: mapSellingAdditionalServiceToServer(service),
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
